export default __webpack_public_path__ + "static/media/fourJokersStory.dc5ce9a9.mp3";